import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { FormField } from "pages/GenericOrder/ui-form/form-field"
import { ModalForm } from "pages/GenericOrder/ui-form/modal-form"
import { useState } from "react"
import { useMutation, useQueryClient } from "react-query"
import { z } from "zod"
import { updateProductSingle } from "../apis"
import { toast } from "sonner"
import { useParams } from "react-router-dom"

const schema = z.object({
    quantity: z
      .number({
        invalid_type_error: 'Quantity is required',
        required_error: 'Quantity is required',
      })
      .min(1, 'Quantity must be at least 1')
      .refine(val => !isNaN(val), {
        message: 'Quantity must be a number',
      }),
  })

type FieldValues = z.infer<typeof schema>

export default function EditProduct({children, product_id, quantity}:{children: React.ReactNode, product_id:string, quantity: number}) {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const {id} = useParams()
    const queryClient = useQueryClient()
    const {mutate, isLoading} = useMutation({
        mutationFn:updateProductSingle,
        onSuccess:()=>{
            queryClient.invalidateQueries(['orderDetails'])
            toast.success('Product updated successfully')
            setIsOpen(false)
        },
        onError: ()=>{
            toast.error('Failed to update product')
        }
    })
    const handleSubmit = (data:FieldValues) =>{
        mutate({
            order_id: Number(id!),
            uuid: product_id,
            fx_amount: data?.quantity
        })
    }
    const defaultValues = {
        quantity
    }
    return (
        <>
            <Button variant='ghost' className="p-0 h-min" onClick={()=>setIsOpen(true)}>
                {children}
            </Button>
            <ModalForm<FieldValues>
                title="Edit Product"
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onSubmit={data=>handleSubmit(data)}
                submitButtonText="Save"                  
                schema={schema} 
                defaultValues={defaultValues}      
                isLoading={isLoading}                                                           
            >
                {
                    (form) => {
                        return (
                            <div className="py-4">
                                <FormField
                                    form={form}                                    
                                    name='quantity'
                                    label="Enter quantity"                                    
                                    render={({ field }) => (
                                        <Input 
                                            {...field} 
                                            type="number"
                                            onChange={e=>field.onChange(parseInt(e.target.value,10))}
                                        />
                                    )}                                                                                                                                            
                                />
                            </div>
                        )
                    }
                }
            </ModalForm>
        </>
    )
}